import { createInstance, type i18n } from "i18next";
import ICU from "i18next-icu";
import { en } from "./locales/en";
import { fr } from "./locales/fr";
import { DEFAULT_LOCALE, type Locale, type MessageKey } from "./types";

export { en, fr };
export * from "./types";

export const catalogs = { fr, en } as const;

export type TranslateValues = Record<string, string | number | Date>;
export type Translate = (key: MessageKey, values?: TranslateValues) => string;

export async function createI18n(locale: Locale = DEFAULT_LOCALE): Promise<i18n> {
  const instance = createInstance();
  await instance.use(ICU).init({
    lng: locale,
    fallbackLng: DEFAULT_LOCALE,
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    interpolation: { escapeValue: false },
    returnNull: false,
  });
  return instance;
}

export function translator(instance: i18n): Translate {
  return (key, values) => instance.t(key, values ?? {});
}
